import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { LoadingPage } from '@foradevelopment/fora-ui';
import { ThunkRequestStatus } from '@fora-monorepo/webapp-types';

import { EmployerMyPagesErrorPage } from '../../components';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { getPayMonthOverviews } from '../../redux/payroll/payrollThunks';
import { getEmployerHasEmployments } from '../../redux/employment/employmentThunks';

export const PayrollDataFetcher = () => {
  const dispatch = useAppDispatch();
  const loadingPayMonthOverviews = useAppSelector(state => state.payroll.loadingPayMonthOverviews);
  const loadingEmployerHasEmployments = useAppSelector(state => state.employment.loadingEmployerHasEmployments);

  const thunkError = useAppSelector(state => state.error.thunkError);

  useEffect(() => {
    dispatch(getEmployerHasEmployments());
    dispatch(getPayMonthOverviews());
  }, [dispatch]);

  if (
    loadingPayMonthOverviews === ThunkRequestStatus.Fulfilled &&
    loadingEmployerHasEmployments === ThunkRequestStatus.Fulfilled
  ) {
    return <Outlet />;
  }
  if (
    loadingPayMonthOverviews === ThunkRequestStatus.Rejected ||
    loadingEmployerHasEmployments === ThunkRequestStatus.Rejected
  ) {
    return <EmployerMyPagesErrorPage type={thunkError?.code} technicalError={thunkError?.message} />;
  }

  return <LoadingPage />;
};
